export const SOURCE_FPS = 'fps' as const;
export const SOURCE_SUBSCRIPTIONS = 'subscriptions' as const;
